/**
 * fieldDb.js — the field-zone IndexedDB (Inventory Screens Step 4.2a).
 *
 * Dexie database `tmg-field`, deliberately SEPARATE from the raw-IDB
 * `tmg-offline` outbox in shared/services/offlineEngine.js — the field
 * capture zone owns its own store and lifecycle ("Delete from device"
 * purges this DB and nothing else).
 *
 * Stores (v1):
 *   records   — one row per Load record. pk record_id (the Cosmos doc id —
 *               NOT tool_id: duplicate tool_ids must coexist, §G). Indexed
 *               by tool_id and site_id.
 *   sites     — the get_field_sites cards, pk site_id.
 *   snapshot  — single fixed-key row 'current': { identity, profile,
 *               cached_at } — the offline identity/profile seed the field
 *               gate reads without a network round-trip.
 *   syncQueue — declared now, EMPTY until Step 4.3 wires the capture
 *               outbox. pk outbox_id; indexed by status, record_id, type.
 *
 * Stores (v2):
 *   refdata   — durable dropdown vocabulary. pk `key`. ONE row holds every
 *               field-zone vocabulary, under the fixed literal
 *               FIELD_REFDATA_KEY (fieldRefData.js):
 *               { key, options: { <field>: [values] }, fields, fetched_at }.
 *               A legacy row under the old derived key may also be present;
 *               it is read once to migrate and never written or deleted.
 *               The store API is readRefData/mergeRefData in fieldStore.js.
 *
 * Dexie opens lazily on first operation. It does NOT auto-reopen after
 * delete()/close(), so every fieldStore op runs through an ensureOpen()
 * guard — that's what makes purge → next-op re-creation transparent.
 */

import Dexie from 'dexie';

export const FIELD_DB_NAME = 'tmg-field';

export const fieldDb = new Dexie(FIELD_DB_NAME);

fieldDb.version(1).stores({
  records: 'record_id, tool_id, site_id',
  sites: 'site_id',
  snapshot: 'id',
  syncQueue: 'outbox_id, status, record_id, type',
});

// v2 declares ONLY the new store — Dexie carries v1's four forward, and
// re-listing them here would let a typo silently drop one.
fieldDb.version(2).stores({ refdata: 'key' });

export default fieldDb;
